module.exports = __webpack_public_path__ + "social.jpg?8be2e71ba524bd749161b7a90b80be73";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social.jpg
// module id = 23
// module chunks = 0